import { useState } from "react";
import MDTypography from "components/MDTypography";
import {
  IconButton,
  Tooltip,
  Dialog,
  DialogContent,
  DialogActions,
  Box,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import { application } from "globals/endpoints";
import { useMaterialUIController } from "context";
import LaunchIcon from "@mui/icons-material/Launch";
import CTLNotification from "../CTLNotification";

function DiscoveredIpAction({ row, onHandleUpdateList }) {
  const ipAddress = row?.original?.ipAddress  || ""; 
  const location = row?.original?.location  || "";
  const [controller, dispatch] = useMaterialUIController();
  const { activePage, darkMode } = controller;
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");

  const handleOpenDialog = () => {
    fetchDropdownOptions();
    setOpenDialog(true);
  };

  const fetchDropdownOptions = () => {
    application
      .post("categoryService/dropdownCategoryCode/list")
      .then((response) => {
        const categories = Array.isArray(response?.data?.data)
          ? response.data.data
          : [];
        setCategoryOptions(categories);
      })
      .catch((error) => {
        console.error("Failed to load dropdown:", error);
        setCategoryOptions([]);
      });
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedCategory("");
  };
  function handleSubmit() {
    if (!selectedCategory) {
      console.log("Category not selected!");
      setNotify({
        isOpen: true,
        status: "First select category From Drop Down", 
        type: "error",
        pagename: "Discovered IP",
      });
      return;
    }
    const data = {
      ipAddress: [ipAddress],
      location: [location],
      category: selectedCategory,
    };
    application
      .post("/discoverIp/create", data)
      .then((response) => {
        handleCloseDialog();
        setNotify({
          isOpen: true,
          status:
            response.data.message + " " + response.data.messageDetail,
          type: "success",
          pagename: "Discovered IP",
        });
        setTimeout(() => {
          onHandleUpdateList();
        }, 1500);
      })
      .catch((error) => {
        handleCloseDialog();
        setNotify({
          isOpen: true,
          status:
            error.response.data.message +
            " " +
            error.response.data.messageDetail,
          type: "error",
          pagename: "Discovered IP",
        });
      });
  }

  function handleUpdate() {
    const data = {
      ipList: [ipAddress],
    };
    application
      .post("/discoverIp/update", data)
      .then((response) => {
        
        setNotify({
          isOpen: true,
          status: response.data.message + " " + response.data.messageDetail,
          type: "success",
          pagename: "Discovered IP",
        });
        setTimeout(()=>{
          onHandleUpdateList();
        },1000)
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          status:
            error.response.data.message +
            " " +
            error.response.data.messageDetail,
          type: "error",
          pagename: "Discovered IP",
        });
      });
  }

  return (
    <>
      <MDTypography variant="caption" fontWeight="medium" color="text">
        <Tooltip title="False-Update">
          <IconButton color="success" onClick={handleUpdate}>
            <LaunchIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Add In-Scada-Asset">
          <IconButton color="primary" onClick={handleOpenDialog}>
            <Add />
          </IconButton>
        </Tooltip>
      </MDTypography>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        sx={{
          "& .MuiDialog-container": {
            alignItems: "flex-start",
          },
          "& .MuiPaper-root": {
            marginTop: "100px",
            borderRadius: "10px",
          },
        }}
      >
        <DialogContent
          sx={{
            backgroundColor: darkMode ? "#1e1e1e" : "#FFFFFF",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "20rem",
            padding: "10px",
            gap: ".7em",
          }}
        >
          <Box width="100%">
            <Box width="100%" display="flex" justifyContent="center">
              <MDTypography variant="button" fontWeight="bold" gutterBottom>
                Select Category
              </MDTypography>
            </Box>
            <Box width="100%">
              <select
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  fontSize: "1rem",
                }}
                value={selectedCategory || ""}
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                <option value="">Select Category</option>
                {categoryOptions.map((category) => (
                  <option
                    key={category?.categoryCode}
                    value={category?.categoryCode}
                  >
                    {category?.categoryName}
                  </option>
                ))}
              </select>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions
          sx={{ backgroundColor: darkMode ? "#1e1e1e" : "#FFFFFF" }}
        >
          <MDBox display="flex" gap={2} padding="10px">
            <MDButton
              variant="gradient"
              color="error"
              size="small"
              onClick={handleCloseDialog}
            >
              Close
            </MDButton>
            <MDButton
              variant="gradient"
              color="success"
              size="small"
              onClick={handleSubmit}
            >
              Submit
            </MDButton>
          </MDBox>
        </DialogActions>
      </Dialog>
      <CTLNotification notify={notify} setNotify={setNotify} />
    </>
  );
}

export default DiscoveredIpAction;
